import CalendarReducer from './calendar-reducer';
import ChatReducer from './chat-reducer';
import NewTaskReducer from './../pages/authorized/new-task/new-task-reducer';
import NotificationReducer from './notification-reducer';
import PhonebookReducer from './phonebook-reducer';
import PushOnReducer from './push-on-reducer';
import RedirectReducer from './redirect-reducer';
import SecretariesReducer from './secretaries-reducer';
import SettingsReducer from './settings-reducer';
import TaskReducer from './../pages/authorized/task/task-reducer';
import TasksReducer from './tasks-reducer';
import UserLimit from './user-limit';
import UserReducer from './user-reducer';
import { combineReducers } from 'redux';
import coworkersReducer from './coworkers-reducer';
import { notistackDispatcherReducer } from '../reducers/notistack-dispatcher-reducer';
import createTransform from 'redux-persist/lib/createTransform';
import persistReducer from 'redux-persist/lib/persistReducer';
import storage from 'redux-persist/lib/storage'; // Now using localStorage

const appReducer = combineReducers({
  user: UserReducer,
  secretaries: SecretariesReducer,
  tasks: TasksReducer,
  notifications: NotificationReducer,
  task: TaskReducer,
  chat: ChatReducer,
  settings: SettingsReducer,
  newTask: NewTaskReducer,
  calendar: CalendarReducer,
  phonebook: PhonebookReducer,
  redirecter: RedirectReducer,
  pushOn: PushOnReducer,
  notifStackDispatcher: notistackDispatcherReducer,
  coworkers: coworkersReducer,
  userLimit: UserLimit,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const dropSearchPending = createTransform(
  (userState) => ({ ...userState, searchPending: false, chatRooms: [] }),
  (userState) => ({ ...userState, searchPending: false, chatRooms: [] }),
  { whitelist: ['user'] }
);

const keepChatPreferencesOnly = createTransform(
  (chatState) => ({ chatWindowOpen: chatState.chatWindowOpen, activeRoom: chatState.activeRoom }),
  (chatState) => ({
    ...ChatReducer(undefined, { type: '@@wwa/chat-rehydrate' }),
    chatWindowOpen: Boolean(chatState?.chatWindowOpen),
    activeRoom: chatState?.activeRoom,
  }),
  { whitelist: ['chat'] }
);

const config = {
  key: 'root', // key is required
  storage, // Now using localStorage
  transforms: [dropSearchPending, keepChatPreferencesOnly],
};

const Reducers = persistReducer(
  config,
  rootReducer
);

export default Reducers;
